export enum ApplicationBookingState {
  INVITED = 'invited',
  RESCHEDULING = 'rescheduling',
  UNAUTHORIZED = 'unauthorized',
  AUTHORIZED = 'authorized',
  CONFIRMED = 'confirmed',
  COMPLETED = 'completed',
}

export enum FrontApplicationBookingState {
  RESCHEDULED = 'rescheduled',
  CANCELLED = 'cancelled',
}

export type BookingState = ApplicationBookingState | FrontApplicationBookingState
